import React, { FC } from 'react';
import { Redirect, RedirectProps, useLocation } from 'react-router-dom';
import { useRouteConfiguration } from '../../hooks/useRouteConfiguration';
import { RouteNames } from '../../routes/routeConstants';
import { pathByRouteName } from '../../util/routes';
import { buildNewSearchString } from '../../util/urlHelpers';

interface NamedRedirectProps {
  name: RouteNames;
  search?: string;
  state?: RedirectProps['to']['state'];
  push?: boolean;
  params?: any;
}

/**
 * This component wraps React-Router's Redirect by providing name-based routing.
 * (Helps to narrow down the scope of possible format changes to routes.)
 */
const NamedRedirect: FC<NamedRedirectProps> = ({
  name,
  search = '',
  state = {},
  params = {},
  push = false,
}) => {
  const routes = useRouteConfiguration();
  const currentLocation = useLocation();

  const pathname = pathByRouteName(name, routes, params);
  const newSearchString = buildNewSearchString(currentLocation, search);
  return <Redirect to={{ pathname, search: newSearchString, state }} push={push} />;
};

export default NamedRedirect;
